let config = {
    buildNumber: "6908",
    cachedAPI: "https://internal-gcp.staging.api.viewlift.com",
    apiBaseUrl:"https://internal-gcp.staging.api.viewlift.com",
    apiKey:  "723648172y3712783y12783728",
    analyticsBaseUrl:"https://analytics-api.staging-livgolfplus.viewlift.com/user-beacon",  // DEPRECATED. No longer needed
    sseBaseUrl: "https://event.staging-livgolfplus.viewlift.com", // DEPRECATED. No longer needed
    wssBaseUrl: "wss://staging-ws.viewlift.com", // DEPRECATED. No longer needed
    appCMSBaseUrl: "https://appcms-gcp.staging.asset.viewlift.com",
    buildAssetsUrl: "https://appcms-gcp.staging.asset.viewlift.com",
    toolsUrl:"https://cms-gcp.staging.viewlift.com",
    newToolsUrl: "https://cms-gcp.staging.viewlift.com",
    internalEmbedBaseURL: "https://internal-gcp.staging.api.viewlift.com",
    paymentWSUrl: "wss://staging-ws.viewlift.com/ws",
    filesProxy: {
        directPaths: [
          '/apple-app-site-association',
          '/.well-known/apple-app-site-association',
          '/.well-known/assetlinks.json',
          '/robots.txt',
          '/ads.txt',
          '/app-ads.txt',
          '/sitemap1.xml',
          '/sitemap2.xml',
          '/sitemap3.xml',
          '/sitemap4.xml',
          '/sitemap5.xml',
          '/sitemap6.xml',
          '/sitemap7.xml',
          '/sitemap8.xml',
          '/sitemap9.xml',
          '/sitemap10.xml',
          '/offline.html',
          '/serviceWorker.js',
          '/sw.js'
        ]
      },
    env:"staging"
   }
   module.exports.config = config;
